export const isPositiveNumber = (value: number):boolean => value >= 0;
